import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from 'react-redux'
import {message} from 'antd';
import {SUCCESS_MESSAGE} from "../../../sagas/notifications";
import './Notification.css'

message.config({
  duration: 5,
})
class Notification extends React.Component {

  render() {
    const {intl:{formatMessage}, notifications} = this.props;
    notifications.notifications.forEach((n)=>{
      const type = n.type || SUCCESS_MESSAGE;
      message[type](formatMessage({id:n.message}))
    });
    return null
  }
}

const mapStateToProps = state => ({
  notifications: state.notifications
});

export default connect(mapStateToProps)(injectIntl(Notification));






// WEBPACK FOOTER //
// ./src/components/common/notification/Notification.js